export default __webpack_public_path__ + "static/media/fa-regular-400.0729f3fe.ttf";